// extracted by mini-css-extract-plugin
var _1 = "RpdaA";
export { _1 as "dateRange" }
